// Open
export const personalTrainerLoginRoute = '/'
export const adminLoginRoute = '/admin'
export const personalTrainerInvitationRoute = '/personal/cadastro'
export const signUpRoute = '/personal/registrar'
export const personalTrainerRecoverPasswordRoute = '/personal/recuperar-senha'

// Authenticated
export const getPrintPagesRoute = (
  studentId = ':student_id',
  evaluationId = ':evaluation_id',
) => `/aluno/resultados/${studentId}/avaliacao/${evaluationId}`

export const demoStudentEvaluationsRoute = 'aluno/avaliacoes/demonstracao'

export const personalHomeRoute = '/'
export const studentEvaluationsRoute =
  '/aluno/:student_id/avaliacoes/:evaluation_id'

export const studentRoutes = {
  evaluation(studentId: string, evaluationId: string) {
    if (!studentId || !evaluationId) {
      throw Error('Invalid route format for studentsRoutes.evaluation')
    }
    return `/aluno/${studentId}/avaliacoes/${evaluationId}`
  },
}

export const anamnesisRoute =
  studentEvaluationsRoute + '/anamnese?subform=<subform>'
export const antropometryRoute = studentEvaluationsRoute + '/antropometria'
export const corporalEvaluationRoute =
  studentEvaluationsRoute + '/avaliacao_corporal'
export const hemodynamicMeasuresRoute =
  studentEvaluationsRoute + '/medidas_hemodinamicas'
export const aerobicCapabilitiesRoute =
  studentEvaluationsRoute + '/capacidade_aerobica'
export const aerobicPrescriptionRoute =
  studentEvaluationsRoute + '/prescricao_aerobica'
export const schedulerRoute = studentEvaluationsRoute + '/agendamento'
export const aerobicExercisesRoute =
  studentEvaluationsRoute + '/exercicios_aerobicos'
export const exercisesPrescriptionsRoute =
  studentEvaluationsRoute + '/prescricao_de_exercicios'
export const standardizedSeriesRoute =
  studentEvaluationsRoute + '/personalizacao_da_serie'

export const personalTrainerProfileRoute = '/perfil'

export const personalTrainerSubscriptionsRoute = 'assinaturas'
export const personalTrainerSubscriptionOffersRoute = '/ofertas'

export const adminRoutes = {
  home: '/admin',
  personalTrainers: (query?: { cpf: string }) => {
    const queryParams = new URLSearchParams()
    if (query?.cpf) {
      queryParams.set('cpf', query.cpf)
    }

    return queryParams.toString()
      ? `/admin/personal-trainers?${queryParams.toString()}`
      : '/admin/personal-trainers'
  },
  // sales: '/admin/vendas',
  sales: {
    root: '/admin/vendas',
    plans: (query?: { plano: string }) => {
      const queryParams = new URLSearchParams()
      if (query?.plano) {
        queryParams.set('plano', query.plano)
      }
      return `/admin/vendas/planos?${queryParams.toString()}`
    },
    subscriptions: '/admin/vendas/assinaturas',
    charges: '/admin/vendas/cobrancas',
    discounts: '/admin/vendas/descontos',
  },
  admins: '/admin/administradores',
  actions: '/admin/actions',
  profile: '/admin/perfil',
  settings: '/admin/configuracoes',
}

export const planCheckoutRoute = '/checkout'
export const registerTrialRoute = '/registro-teste'
